export const CARD_BACKGROUND_COLORS = {
    DARK_BLUE: "#183059",
    GREEN: "#008C23",
    YELLOW: "#F9E719",
    RED: "#EE3B2B"
  };
  
  export const TEXT_COLORS = {
    WHITE: "#FFFFFF",
    BLACK: "#1F242E"
  };